import * as utilsTypes from './utilsTypes';
import cloneDeep from 'lodash.clonedeep';

const initState = {
  drawerState: {
    left: {
      open: false,
      anchor: 'left',
    },
    right: {
      open: false,
      anchor: 'right',
    },
  },
  notifications: [],
  history: [],
};

const utilsReducer = (state = initState, action) => {
  switch (action.type) {
    case utilsTypes.TOGGLE_DRAWER: {
      let res = cloneDeep(state);

      res.drawerState[action.anchor].open = action.payload;

      return res;
    }

    case utilsTypes.SHOW_NOTIFICATION:
      return {
        ...state,
        notifications: [{ ...action.notification }, ...state.notifications],
      };

    case utilsTypes.REMOVE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(notification => notification.index !== action.index),
      };

    case utilsTypes.ADD_TO_HISTORY:
      return {
        ...state,
        history: [...state.history, { url: action.url, params: action.params }],
      };

    default: {
      return state;
    }
  }
};

export { initState };
export default utilsReducer;



// WEBPACK FOOTER //
// ./src/utils/utilsReducer.js